/** Default auto-dismiss for error toasts (and legacy callers that pass this). */
export const ERROR_TOAST_DURATION_MS = 8000;
export const SUCCESS_TOAST_DURATION_MS = 5000;
export const INFO_TOAST_DURATION_MS = 5000;

export const MESSAGE_HISTORY_LIMIT = 10;
export const MESSAGE_HOVER_LIMIT = 3;

export const TOAST_PLACEMENT = {
  DEFAULT: "default",
  MAP_SAVE: "map-save",
  MAP_CENTER: "map-center",
};

/** Routes where the bottom-right message console is shown. */
export const MESSAGE_CONSOLE_PATHS = [
  "/project-administration",
  "/collections",
  "/map-editor",
];

export const isMessageConsolePath = (pathname) =>
  MESSAGE_CONSOLE_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
